import { MESSAGES } from "@app/constant";
import { throwImageFiltering } from "@app/helpers/uploadFileValidation";

import { handleDeleteImageProps, onChangeUploadProps } from "./types";

export const onChangeUpload = ({
  event,
  keyExistingImages,
  keyUploadedFileList,
  multiple,
  watch,
  setValue,
  setState,
  setError,
}: onChangeUploadProps) => {
  setState((prev) => ({ ...prev, largeImageMessage: '' }))
  setError(keyUploadedFileList, { message: '' })

  const existingImages = watch(keyExistingImages) // cames from backend
  const uploadedFileList = watch(keyUploadedFileList) // new uploaded filelist
  const isFileList = uploadedFileList instanceof FileList;

  const calcedCount = isFileList ? uploadedFileList?.length || 0 : uploadedFileList ? 1 : 0

  try {
    const fileList = event.target?.files as FileList;
    const onChangeFiles = throwImageFiltering(fileList)

    // sum length backend and frontend images count;
    const chosenImagesLength = (onChangeFiles?.length || 0) + (existingImages ? existingImages.length : 0)

    if (!onChangeFiles) {
      setError(keyUploadedFileList, { message: MESSAGES.imageIsRequired })
    }

    if (((calcedCount) + chosenImagesLength) > 5) {
      setError(keyUploadedFileList, { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList?.length !== onChangeFiles?.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    if (!multiple) {
      setValue(keyUploadedFileList, fileList)
      setValue(keyExistingImages, [])

      return
    }

    if (isFileList && uploadedFileList !== null) {
      const newDataTransfer = new DataTransfer();

      [
        ...Array.from(uploadedFileList),
        ...Array.from(fileList)
      ].forEach((file) => {
        newDataTransfer.items.add(file);
      });

      setValue(keyUploadedFileList, newDataTransfer.files)

      return
    }

    setValue(keyUploadedFileList, fileList)
  } catch (error) {
    console.log('Error:', error);
  }
}

export const handleDeleteImage = ({
  bas64,
  previews,
  images,
  watch,
  setValue,
  setState,
}: handleDeleteImageProps) => {
  const isFileList = images instanceof FileList

  const existingImages = watch('existingImages')
  const index = previews.findIndex((item) => item === bas64);

  if (existingImages) {
    const [_, name] = bas64.split('images/')

    const files = existingImages.filter((item) => item.url !== `images/${name}`)

    setValue('existingImages', [...files])
    setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
  }

  if (isFileList) {
    const files = Array.from(images).filter((_, i) => i !== index);

    const mergedFileList = new DataTransfer();

    files.forEach((file: any) => {
      mergedFileList.items.add(file);
    });

    setValue('uploadedFileList', mergedFileList.files)
    setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
  }
}
